// extracted by mini-css-extract-plugin
export var documentation = "style-module--documentation--a166e";